import React, { useState } from 'react'
import { Box, chakra, Flex, Stack, Tab, TabList, TabPanel, TabPanels, Tabs, useToast } from '@chakra-ui/react'
import { useGetUsersByType } from 'api/project-details'
import { OrderIntakeForm } from './order-intake-form'
import { useForm, FormProvider } from 'react-hook-form'
import { parseNewTicketFormValuesToPayload, useCreateTicket } from 'api/ticket'
import { Card } from 'components/card/card'

type Props = {
  propertyId: any
}
export const NewTicketFlow: React.FC<Props> = (props): JSX.Element => {
  const { propertyId } = props

  const defaultFormValues = () => {
    return {
      sowOriginalContractAmount: '',
      propertyId: propertyId,
      schedule: [
        {
          preferredStartDate: null,
          preferredStartTime: null,
        },
        {
          preferredStartDate: null,
          preferredStartTime: null,
        },
        {
          preferredStartDate: null,
          preferredStartTime: null,
        },
      ],
      tradeAndDescription: [
        {
          vendorTrade: null,
          issueDescription: null,
          company: null,
          isNew: true,
        },
      ],
    }
  }

  const formReturn = useForm<any>({
    defaultValues: defaultFormValues(),
  })

  const { handleSubmit } = formReturn

  const { userSelectOptions: maintenanceCoordinatorSelectOptions } = useGetUsersByType(112)
  const { userSelectOptions: fpmAsMaintenanceSpecialistSelectOptions } = useGetUsersByType(5)

  const { mutate: createTicket, isLoading } = useCreateTicket()
  const [isNotesRequired, setIsNotesRequired] = useState(false)
  const toast = useToast()

  const onSubmit = values => {
    const payload = parseNewTicketFormValuesToPayload(values)

    createTicket(payload, {
      onSuccess: (res: any) => {
        setIsNotesRequired(false)
        toast({
          title: 'Ticket',
          description: 'New ticket created successfully',
          status: 'success',
          isClosable: true,
          position: 'top-left',
        })
      },
      onError: (error: any) => {
        toast({
          title: 'Ticket',
          description: (error.title as string) ?? 'Unable to create ticket.',
          status: 'error',
          duration: 9000,
          isClosable: true,
          position: 'top-left',
        })
      },
    })
  }

  return (
    <FormProvider {...formReturn}>
      <chakra.form onSubmit={handleSubmit(onSubmit)}>
        <Stack w={{ base: '971px', xl: '100%' }} spacing={'16px'} h="calc(100vh - 160px)">
          <Stack w={{ base: '971px', xl: '100%' }} spacing={5} pb="4">
          
            <Tabs 
              size="sm" 
              variant="enclosed" 
              colorScheme="brand"
             >
              <TabList h={'50px'} alignItems="end" border="none">
                <Flex ml="9px" h={'40px'} py={'1px'}>
                  <Tab>Ticket Details</Tab>
                </Flex>
              </TabList>

              <Card
                ml="9px"
                paddingTop="10px !important"
                padding="0px !important"
                rounded="0px"
                roundedRight={{ base: '0px', md: '6px' }}
                roundedBottom="6px"
                boxShadow={'unset'}
                pr={{ base: 0, sm: '15px' }}
              >
                <TabPanels h="100%">
                  <TabPanel p="0px" width="100%">
                    <Box p="3">
                      <OrderIntakeForm
                       isLoading={isLoading}
                       isNotesRequired={isNotesRequired}
                       setIsNotesRequired={setIsNotesRequired}
                        maintenanceCoordinatorSelectOptions={maintenanceCoordinatorSelectOptions}
                        maintenanceSpecialistSelectOptions={fpmAsMaintenanceSpecialistSelectOptions}
                        propertyId={propertyId}
                      />
                    </Box>
                  </TabPanel>
                  <TabPanel p="0px" h="100%" mt="7px"></TabPanel>
                  <TabPanel p="0px"></TabPanel>
                  <TabPanel p="0px" minH="calc(100vh - 409px)"></TabPanel>
                  <TabPanel p="0px"></TabPanel>

                  {/* <TabPanel px="0">
              <TriggeredAlertsTable
                onRowClick={(e, row) => {
                  selectedAlertRow(row.values)
                  onAlertModalOpen()
                }}
                ref={tabsContainerRef}
              />
            </TabPanel> */}

                  <TabPanel p="0" minH="calc(100vh - 408px)"></TabPanel>
                </TabPanels>
              </Card>
            </Tabs>
          </Stack>
        </Stack>
      </chakra.form>
    </FormProvider>
  )
}
